/** Apex membership picker after Sign in on the marketing overlay. */
export const SAAS_COMMUNITIES_PATH = '/saas/communities/';

/**
 * Apex marketing overlay (`NEXT_PUBLIC_SAAS_HOST_UI`) — not tenant or paydirt Hosting.
 * Next only inlines `process.env.NEXT_PUBLIC_*` on a direct member access. Do not pass
 * `process.env` as an object and read the key from it in client bundles.
 */
export const SAAS_HOST_UI = process.env.NEXT_PUBLIC_SAAS_HOST_UI === 'true';

export function saasHostUiEnabled(env?: Record<string, string | undefined>): boolean {
  if (env) {
    return env.NEXT_PUBLIC_SAAS_HOST_UI === 'true';
  }
  return process.env.NEXT_PUBLIC_SAAS_HOST_UI === 'true';
}

/** Apex Sign in returns to the picker; tenant product Sign in stays on the current site. */
export function saasHostLoginReturnTo(env?: Record<string, string | undefined>): string {
  return saasHostUiEnabled(env) ? SAAS_COMMUNITIES_PATH : '/';
}
